export interface ActionType{
  title: string;
  titleKey: string;
  tipo: string;
}

export const GET:ActionType = {
  title:"",
  titleKey:"",
  tipo:"G"
}

export const UPDATE:ActionType = {
  title:"Editar Usuario",
  titleKey:"editar-usuario",
  tipo:"U"
}

export const CREATE: ActionType = {
  title:"Nuevo Usuario",
  titleKey:"nuevo-usuario",
  tipo:"I"
}

export const ADDSOC: ActionType = {
  title:"Gestión de Sociedades",
  titleKey:"gestion-sociedades",
  tipo:"S"
}

export const ADDDEL: ActionType = {
  title:"Gestión de Delegados",
  titleKey:"gestion-delegados",
  tipo:"D"
}